module.exports = __webpack_public_path__ + "images/emoji/cl.7da8cb88e4ec7328139c.png";